import { Action } from '@ngrx/store';
import * as models from '../../domain/models';
import * as viewModels from '../../view/view-models';

export const LOAD = '[Sourcing Aircraft Collection] Load';
export const LOAD_SUCCESS = '[Sourcing Aircraft Collection] Load Success';
export const LOAD_FAIL = '[Sourcing Aircraft Collection] Load Fail';

export class LoadPayload {
  constructor(public operatorId: string) {}
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadPayload) {}
}

export class LoadSuccessPayload {
  constructor(public items: Array<models.Aircraft>) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
